const usersData = [
  {
    id: 0,
    name: "John Doe",
    registered: "2018/01/01",
    role: "Guest",
    status: "Pending",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 1,
    name: "Samppa Nori",
    registered: "2018/01/01",
    role: "Member",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 2,
    name: "Estavan Lykos",
    registered: "2018/02/01",
    role: "Staff",
    status: "Banned",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 3,
    name: "Chetan Mohamed",
    registered: "2018/02/01",
    role: "Admin",
    status: "Inactive",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 4,
    name: "Derick Maximinus",
    registered: "2018/03/01",
    role: "Member",
    status: "Pending",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 5,
    name: "Friderik Dávid",
    registered: "2018/01/21",
    role: "Staff",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 6,
    name: "Yiorgos Avraamu",
    registered: "2018/01/01",
    role: "Member",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 7,
    name: "Avram Tarasios",
    registered: "2018/02/01",
    role: "Staff",
    status: "Banned",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 8,
    name: "Quintin Ed",
    registered: "2018/02/01",
    role: "Admin",
    status: "Inactive",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 9,
    name: "Enéas Kwadwo",
    registered: "2018/03/01",
    role: "Member",
    status: "Pending",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 10,
    name: "Agapetus Tadeáš",
    registered: "2018/01/21",
    role: "Staff",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 11,
    name: "Carwyn Fachtna",
    registered: "2018/01/01",
    role: "Member",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 12,
    name: "Nehemiah Tatius",
    registered: "2018/02/01",
    role: "Staff",
    status: "Banned",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 13,
    name: "Ebbe Gemariah",
    registered: "2018/02/01",
    role: "Admin",
    status: "Inactive",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 14,
    name: "Eustorgios Amulius",
    registered: "2018/03/01",
    role: "Member",
    status: "Pending",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 15,
    name: "Leopold Gáspár",
    registered: "2018/01/21",
    role: "Staff",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 16,
    name: "Pompeius René",
    registered: "2018/01/01",
    role: "Member",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 17,
    name: "Paĉjo Jadon",
    registered: "2018/02/01",
    role: "Staff",
    status: "Banned",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 18,
    name: "Micheal Mercurius",
    registered: "2018/02/01",
    role: "Admin",
    status: "Inactive",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 19,
    name: "Ganesha Dubhghall",
    registered: "2018/03/01",
    role: "Member",
    status: "Pending",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 20,
    name: "Hiroto Šimun",
    registered: "2018/01/21",
    role: "Staff",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 21,
    name: "Vishnu Serghei",
    registered: "2018/01/01",
    role: "Member",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 22,
    name: "Zbyněk Phoibos",
    registered: "2018/02/01",
    role: "Staff",
    status: "Banned",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 23,
    name: "Einar Randall",
    registered: "2018/02/01",
    role: "Admin",
    status: "Inactive",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 24,
    name: "Félix Troels",
    registered: "2018/03/21",
    role: "Staff",
    status: "Active",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 25,
    name: "Aulus Agmundr",
    registered: "2018/01/01",
    role: "Member",
    status: "Pending",
    details: {
      email: "test@zoha.com",
      name: "ادمین",
      last_name: "ضحا پاور",
      coName: "مهرآور پیشرو گستران ایرانیان",
      phone: "989123456789",
      website: "https://example.com",
      country: "ایران",
      city: "یزد",
      code_p: "44772244",
      addres: "بیابان های کویری بعد از کاکتوس شماره 395",
      code_m: "0011002200",
    },
  },
  {
    id: 42,
    name: "Ford Prefex",
    registered: "2001/05/21",
    role: "Alien",
    status: "Don't panic!",
  },
];

export default usersData;
